import * as React from 'react';
import {
  RATIO,
  TypographySize,
  SEMANTIC_TAG,
} from 'mm-theme-configuration/dist/consts';
import { CardComponentDataProps } from '../../partials/cards/cards.utils';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { useThemeOverride } from '../../../theming/useThemeOverride';
import {
  componentConfigThemeKey as horizontalCardConfigThemeKey, HorizontalCardThemeProps,
} from '../../partials/cards/horizontalCard/HorizontalCard';
import { ThemeContext } from '../../../theming/ThemeProviderWithFonts';
import { createImageWidths } from '../../partials/image/image.utils';
import { TenHC } from './TenHC';
import { useTheme } from '../../../theming/useTheme';

interface TenHCForOneThirdsDataProps {
    cards: Array<CardComponentDataProps>;
}
export const componentConfigThemeKey = 'tenHCForOneThird';

const imageWidths = createImageWidths(180, 180, 180);

export interface TenHCForOneThirdThemeProps {
  aspectRatioLarge: RATIO;
  aspectRatioMedium: RATIO;
  aspectRatioSmall: RATIO;
  titleFontSizeLarge: TypographySize;
  titleFontSizeMedium: TypographySize;
  titleFontSizeSmall: TypographySize;
  metadataFontSizeLarge: TypographySize;
  metadataFontSizeMedium: TypographySize;
  metadataFontSizeSmall: TypographySize;
  titleSemanticTag: SEMANTIC_TAG;
  metadataSemanticTag: SEMANTIC_TAG;
  pipeColor: string;
  showDescriptionInLargeScreen: boolean;
  showDescriptionInMediumScreen: boolean;
  showDescriptionInSmallScreen: boolean;
  verticalGapLarge: number;
  verticalGapMedium: number;
  verticalGapSmall: number;
  horizontalGapLarge: number;
  horizontalGapMedium: number;
  horizontalGapSmall: number;
}

export const TenHCForOneThird: React.FunctionComponent<TenHCForOneThirdsDataProps> = props => {
  const { cards } = props;
  const themeProps = useTheme<TenHCForOneThirdThemeProps>(componentConfigThemeKey);
  const themeContextHC = useThemeOverride<HorizontalCardThemeProps>(themeProps, horizontalCardConfigThemeKey);
  return (
    <ErrorBoundary>
      <ThemeContext.Provider value={themeContextHC}>
        <TenHC cards={cards} paddingFactors={{ large: 0, medium: 0, small: 0 }} imageWidths={imageWidths} />
      </ThemeContext.Provider>
    </ErrorBoundary>
  );
};
